import { useTranslation } from 'react-i18next';
    
export default function Translation(props) {

 const { t, i18n } = useTranslation();

  return props?.data?  t(props.data) :''
}
